module.exports = __webpack_public_path__ + "static/img/Bag-On.2daa7691.svg";